<template>
    <form @submit.prevent="handleUpdateCompany" v-if="company" class="is-clearfix">
        <h1 class="title is-3">Edit company</h1>
        <div class="columns">
            <div class="column">
                <o-field label="Company name" :type="fieldType('name')" :message="getError('name')">
                    <o-input v-model="company.name"/>
                </o-field>

                <o-field label="Address" :type="fieldType('address')" :message="getError('address')">
                    <o-input v-model="company.address"/>
                </o-field>

                <o-field label="City" :type="fieldType('city')" :message="getError('city')">
                    <o-input v-model="company.city"/>
                </o-field>

                <o-field label="State" :type="fieldType('state')" :message="getError('state')">
                    <o-select placeholder="Select a state" v-model="company.state" expanded>
                        <option
                            v-for="state in states"
                            :value="state.id"
                            :key="state.id">
                            {{ state.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="Zip" :type="fieldType('zip')" :message="getError('zip')">
                    <o-input v-model="company.zip"/>
                </o-field>

                <o-field label="Phone" :type="fieldType('phone')" :message="getError('phone')">
                    <o-input v-model="company.phone"/>
                </o-field>

                <o-field label="Fax" :type="fieldType('fax')" :message="getError('fax')">
                    <o-input v-model="company.fax"/>
                </o-field>

                <o-field label="Email"
                    :type="fieldType('email')"
                    :message="getError('email')">
                    <o-input
                            placeholder="company@example.com"
                            v-model="company.email"
                            type="email"
                    />
                </o-field>

                <o-field label="Notes" :type="fieldType('notes')" :message="getError('notes')">
                    <quill-editor v-model:content="company.notes" :content-type="'html'" :toolbar="editorToolbar"/>
                </o-field>
            </div>

            <div class="column">
                <o-field label="Lead Owner">
                    <autocomplete-select type="user" v-model="company.lead_owner" :error="getError('lead_owner')" />
                </o-field>

                <o-field label="IBM Number" :type="fieldType('ibm_number')" :message="getError('ibm_number')">
                    <o-input v-model="company.ibm_number"/>
                </o-field>

                <o-field label="IBM Number expiration date" :type="fieldType('ibm_exp_date')" :message="getError('ibm_exp_date')">
                    <datepicker v-model="company.ibm_exp_date" />
                </o-field>

                <o-field label="Tax ID" :type="fieldType('tax_id')" :message="getError('tax_id')">
                    <o-input v-model="company.tax_id"/>
                </o-field>

                <o-field label="HIC License" :type="fieldType('hic_license')" :message="getError('hic_license')">
                    <o-input v-model="company.hic_license"/>
                </o-field>

                <o-field label="DOB Tracking" :type="fieldType('dob_tracking')" :message="getError('dob_tracking')">
                    <o-input v-model="company.dob_tracking"/>
                </o-field>

                <o-field label="DOB Tracking expiration date" :type="fieldType('dob_tracking_exp_date')" :message="getError('dob_tracking_exp_date')">
                    <datepicker v-model="company.dob_tracking_exp_date" />
                </o-field>

                <o-field label="Special Inspection Agency" :type="fieldType('special_inspection_agency')" :message="getError('special_inspection-agency')">
                    <o-input v-model="company.special_inspection_agency"/>
                </o-field>

                <div class="block">
                    <label class="label">Is this client a task-based location?</label>
                    <o-radio :native-value="true" v-model="company.task_based">Yes</o-radio>
                    <o-radio :native-value="false" v-model="company.task_based">No</o-radio>
                </div>
            </div>
        </div>

        <div class="field is-grouped is-pulled-right">
            <p class="control">
                <router-link :to="{ name: 'companies.index' }" class="button" >Cancel</router-link>
            </p>
            <p class="control">
                <button @click.prevent="confirmCustomDelete" class="button is-danger">Delete</button>
            </p>
            <p class="control">
                <button class="button is-success">Save</button>
            </p>
        </div>
    </form>
</template>

<script>
    import { QuillEditor } from '@vueup/vue-quill';
import { mapActions, mapGetters } from 'vuex';
import Datepicker from './../../components/Datepicker';
import HandlesForm from './../../mixins/HandlesForm';

    export default {
        mixins: [HandlesForm],

        components: {
            Datepicker,
            QuillEditor
        },

        computed: {
            ...mapGetters(['states', 'editorToolbar'])
        },

        mounted () {
            this.fetchCompanyById(this.$route.params.slug).then(response => {
                this.company = response.data.data
            })
        },

        data() {
            return {
                company: null,
                radio: 'Vane'
            }
        },

        methods: {
            ...mapActions(['fetchCompanyById', 'updateCompany']),

            handleUpdateCompany() {
                let submit = this.wrapSubmit(this.updateCompany)
                submit(this.company)
                    .then(res => {
                        this.success()
                        this.$router.push(`/companies/${res.data.data.id}`)
                        return res
                    })
            },

            success() {
                this.$swal.fire({
                    text: 'Company has been updated',
                    icon: 'success'
                })
            },

            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting contact',
                    text: 'Are you sure you want to <strong>delete</strong> this contact? This action cannot be undone.',
                    confirmText: 'Delete Contact',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Contact deleted!')
                    }
                })
            }
        }
    }
</script>
